<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Шүүлтүүр
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Хугацаа (эхлэх)</label>
          <flat-pickr
            v-model="due_date_from"
            class="form-control"
            :config="{ dateFormat: 'Y-m-d' }"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Хугацаа (дуусах)</label>
          <flat-pickr
            v-model="due_date_to"
            class="form-control"
            :config="{ dateFormat: 'Y-m-d' }"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Харилцагчийн ID</label>
          <b-form-input
            v-model="customer_id"
            placeholder="12345"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Зээлийн дансны ID</label>
          <b-form-input
            v-model="loan_account_id"
            placeholder="12345"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Төлөв</label>
          <b-form-input
            v-model="status"
            placeholder="sent"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Trigger төрөл</label>
          <b-form-input
            v-model="trigger_type"
            placeholder="scheduled"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12">
          <b-button
            variant="outline-primary"
            class="_report_submit_button mr-1"
            @click="filterLoanEbarimt()"
          >
            <span class="text-nowrap">Хайх</span>
          </b-button>
          <b-button
            variant="outline-secondary"
            class="_report_submit_button"
            @click="clearFilter()"
          >
            <span class="text-nowrap">Цэвэрлэх</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormInput,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    flatPickr,
    BFormInput,
  },
  props: {
    loanEbarimtFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      due_date_from: '',
      due_date_to: '',
      customer_id: '',
      loan_account_id: '',
      status: '',
      trigger_type: '',
    }
  },
  methods: {
    filterLoanEbarimt() {
      const filter = {}
      if (this.due_date_from) filter.due_date_from = this.due_date_from
      if (this.due_date_to) filter.due_date_to = this.due_date_to
      if (this.customer_id) filter.customer_id = this.customer_id
      if (this.loan_account_id) filter.loan_account_id = this.loan_account_id
      if (this.status) filter.status = this.status
      if (this.trigger_type) filter.trigger_type = this.trigger_type
      this.$emit('update:loanEbarimtFilter', filter)
    },
    clearFilter() {
      this.due_date_from = ''
      this.due_date_to = ''
      this.customer_id = ''
      this.loan_account_id = ''
      this.status = ''
      this.trigger_type = ''
      this.$emit('update:loanEbarimtFilter', {})
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
  ._report_submit_button {
    margin-top: 19px;
  }
</style>
